import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Disable all console logs and debug messages in production
if (environment.production) {
  const methods: (keyof Console)[] = ['log', 'debug'];
  methods.forEach(method => {
    if (typeof console[method] === 'function') {
      (console as any)[method] = () => {};
    }
  });
}
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
